module.exports = __webpack_public_path__ + "static/media/promulgation-landing-promo-truck.63777f9d.png";